import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6810404e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-eer-breaches" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Breaches", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_5 = { class: "radiobutton-horizontal ml-4" }
const _hoisted_6 = { class: "radio ml-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Yes")
], -1))
const _hoisted_8 = { class: "radio" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt mt-2 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "No")
], -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "ls-table ml-4" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { "data-label": "Name" }
const _hoisted_17 = { "data-label": "Breach code" }
const _hoisted_18 = { "data-label": "Legislation" }
const _hoisted_19 = { "data-label": "Description" }
const _hoisted_20 = { "data-label": "Action" }
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"0.5rem"} }, "For the breaches reported above, please add any comments below:", -1))
const _hoisted_25 = { class: "textarea_box ml-4" }

export function render(_ctx, _cache) {
  const _component_AddBreachesModal = _resolveComponent("AddBreachesModal")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", {
      class: _normalizeClass(["questions-main", _ctx.checkCanGoNext() ? 'answered' : ''])
    }, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.newWording), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "breaches",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
            value: 1
          }, null, 512), [
            [_vModelRadio, _ctx.selectedOption]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("label", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            name: "breaches",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedOption) = $event)),
            value: 2
          }, null, 512), [
            [_vModelRadio, _ctx.selectedOption]
          ]),
          _hoisted_9
        ])
      ]),
      (_ctx.selectedOption === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("table", _hoisted_11, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      class: _normalizeClass([ h.sortable ? 'sortable' : '']),
                      onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(h.text), 1),
                        (h.sortable)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                            }, _hoisted_15, 2))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_12))
                  }), 256))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breachesListDisplay, (b, index) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(b.breachType?.name), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(b.breachCode), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(b.legislation), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(b.description), 1),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("button", {
                        class: "btn-icon btn-secondary sml",
                        disabled: _ctx.isRemoving,
                        onClick: $event => (_ctx.removeBreach(b.id))
                      }, _hoisted_23, 8, _hoisted_21)
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-secondary ma-4",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.showAddBreachesModal = true))
            }, "Search and add breach"),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.breaches.breachesComment) = $event)),
                style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                maxlength: 5000,
                placeholder: "External Examiner comments",
                onKeyup: _cache[4] || (_cache[4] = $event => (_ctx.checkCanGoNext()))
              }, null, 544), [
                [_vModelText, _ctx.breaches.breachesComment]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["footnote", [_ctx.breaches.breachesComment?.length === 5000 ? 'full' : '']])
              }, _toDisplayString(_ctx.breaches.breachesComment?.length || 0) + "/5000 characters ", 3)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showAddBreachesModal)
      ? (_openBlock(), _createBlock(_component_AddBreachesModal, {
          key: 0,
          onClose: _cache[5] || (_cache[5] = $event => (_ctx.showAddBreachesModal = false)),
          breaches: _ctx.breaches.breaches,
          "onUpdate:breaches": _cache[6] || (_cache[6] = $event => ((_ctx.breaches.breaches) = $event)),
          onAddBreaches: _cache[7] || (_cache[7] = $event => (_ctx.addBreaches()))
        }, null, 8, ["breaches"]))
      : _createCommentVNode("", true)
  ]))
}